import React, {Fragment, useEffect} from "react";
import {observer} from "mobx-react-lite";
import {
    Chart,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartCategoryAxisTitle,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartTitle,
    ChartTooltip,
    exportVisual
} from '@progress/kendo-react-charts';

import {useStore} from '../../../app/stores/store';
import LoadingComponent from "../../../app/layout/LoadingComponent";
import {Button, Header} from "semantic-ui-react";
import {exportSVG} from "@progress/kendo-drawing";
import {saveAs} from "@progress/kendo-file-saver";


export default observer(function SavingPerDepartment() {
    const {ideaStore} = useStore();
    let {
        loadSavingPerDepartmentReportData, savePerDepartmentChartData,
        loadingInitial
    } = ideaStore;

    const refContainer: any = React.useRef();

    const onExportVisual = () => {
        const chartVisual = exportVisual(refContainer.current);
        if (chartVisual) {
            exportSVG(chartVisual).then(dataURI => saveAs(dataURI, 'SavingPerDepartment.svg'));
        }
    };

    let todaysDate: Date = new Date();

    useEffect(() => {
        loadSavingPerDepartmentReportData();
    }, [])

    //const savePerBusinessChartDataJS = toJS(savePerBusinessChartData)
    const series = [
        {
            field: 'saving',
            categoryField: "partyGroup",
            savingType: 'Actual',
            stack: true,
            note: "difference",
            color: "green",
            notes: 'notesGreen'
        },
        {
            field: 'saving',
            categoryField: "partyGroup",
            savingType: 'Estimate',
            stack: true,
            note: "difference",
            color: "blue",
            notes: 'notesRed'
        },

    ]
    const notesGreen: any = {
        label: {
            position: 'inside',
            color: 'white',
            background: 'green',
        },
        line: {
            length: 30
        },
        icon: {
            type: 'square'
        },
        position: 'top',
    };

    const notesRed: any = {
        label: {
            position: 'inside',
            color: 'white',
            background: 'red',
        },
        line: {
            length: 30
        },
        icon: {
            type: 'square'
        },
        position: 'top',
    };


    if (loadingInitial) return <LoadingComponent content='Generating report...'/>
    return (

        <Fragment>
            <Chart ref={refContainer}>
                <ChartTitle
                    text={todaysDate.toLocaleString()}
                    color="blue"
                    font="10pt sans-serif"
                />
                <ChartTooltip/>
                <ChartLegend position="bottom" orientation="vertical" height={100} width={4}/>
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem labels={{rotation: -10}}>
                        <ChartCategoryAxisTitle text="Departments"/>
                    </ChartCategoryAxisItem>
                </ChartCategoryAxis>
                <ChartLegend position="top" orientation="horizontal"/>
                <ChartSeries>
                    {series.map((serie, index, series) => {
                        let seriesData = savePerDepartmentChartData.filter(item => item.savingType === serie.savingType);
                        if (seriesData.length > 0)
                            if (serie.savingType === 'Estimate') {
                                return <ChartSeriesItem type="column"
                                                        data={seriesData}
                                                        field={serie.field}
                                                        categoryField={serie.categoryField}
                                                        name={serie.savingType}
                                                        noteTextField={serie.note}
                                                        notes={notesRed}
                                                        color={serie.color}
                                                        labels={{visible: true, position: 'center'}}/>
                            } else {


                                return <ChartSeriesItem type="column"
                                                        data={seriesData}
                                                        field={serie.field}
                                                        categoryField={serie.categoryField}
                                                        name={serie.savingType}
                                                        noteTextField={serie.note}
                                                        notes={notesGreen}
                                                        color={serie.color}
                                                        labels={{visible: true, position: 'center'}}/>
                            }

                    })}
                </ChartSeries>
            </Chart>
            <Button onClick={() => onExportVisual()}>Export as visual element</Button>
            <Header as='h4' color='orange'>
                Report values are in Thousands Saudi Riyals
            </Header>
        </Fragment>
    );
})
//const nestedTooltipRender = ({ point:any }) => (<span><b>Series 1 value: {point.value}</b></span>);

/*return <ChartSeriesItem type="column"
                        data={seriesData}
                        field={serie.field}
                        categoryField={serie.categoryField}
                        name={serie.savingType}
                        noteTextField={serie.note}
                        notes={notes}
                        color={serie.color}
                        labels={{visible: true, position: 'center'}}>

  <ChartSeriesItemTooltip render={nestedTooltipRender} />

</ChartSeriesItem>*/







